/*
 * @Author: Tina Huang
 * @Date: 2024-03-04 12:39:55
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:51:06
 * @Description:
 */

import { news } from '@/constants/notifies'
import NewItem from './item'

export default function News() {
  const _tops = news.filter((item) => item.show && item.type === 'top')
  const _news = news.filter((item) => item.show && item.type !== 'top')
  // const titles = _news.map((item) => item?.title)
  const isMobile = window.innerWidth <= 750
  return (
    <div className={`${isMobile ? 'w-full' : 'w-1/2 m-auto'}`}>
      {/* <div>
        {titles.map((t) => (
          <li key={t}>{t}</li>
        ))}
      </div> */}
      {_tops.map((item) => (
        <NewItem key={item.msg} item={item} />
      ))}
      {_news.map((item) => (
        <NewItem key={item.msg} item={item} />
      ))}
    </div>
  )
}
